$(function() {
    
    const char_limit = 450;


    $(document).ready(()=>{
        
        const selector = document.querySelector('.collection-subcategories-mobile .collection-subcategories-wrapper');
        if(selector){
            const active_element = selector.querySelector('.active');
            const active_position = active_element.getBoundingClientRect().left;
            let active_width = active_element.offsetWidth;
            active_element == selector.firstElementChild ? active_width = 0 : '';
            selector.scrollBy(active_position - window.innerWidth / 2 + active_width/2, 0);
        }

        if($('.collection-footer-description').length) {
            let collection_description = $('.collection-footer-description__content').text();
            let truncate_text = collection_description.substr(0, char_limit);

            if(collection_description.length > char_limit){
                $('.collection-footer-description__content').html(truncate_text + '...');
                $('.collection-footer-description').toggleClass('collapsed');
            }
        }
    });

    if($('.collection-footer-description').length) {
        let collection_description = $('.collection-footer-description__content').text();
        let truncate_text = collection_description.substr(0, char_limit);

        $(document).on('click', '.collection-footer-description .button', function(){
            $(this).closest('.collection-footer-description').toggleClass('collapsed');
            if(!$(this).closest('.collection-footer-description').hasClass('collapsed'))
                $('.collection-footer-description__content').html(collection_description);
            else
                $('.collection-footer-description__content').html(truncate_text + '...');
        });
    }

    $(document).on('click', '.collection-header__filters-button', function(){
        $('#CollectionSection').find('#main-collection-filters').toggleClass("open");
        $('body').toggleClass('filters-open');
    });



    Shopify.queryParams = {};

    if (location.search.length) {
        var params = location.search.substr(1).split('&');

        for (var i = 0; i < params.length; i++) {
            var keyValue = params[i].split('=');

            if (keyValue.length) {
                Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
            }
        }
    }

    $(document).on('click', '.collection-header__sorting .sorting__list li input', function(e) {
        var value = e.target.value;
        Shopify.queryParams.sort_by = value;
        location.search = new URLSearchParams(Shopify.queryParams).toString();
    });

});